import React from 'react';
import './SplashScreen.css';

function SplashScreen({ onClose }) {
  return (
    <div className='dialogbackground' onClick={onClose}>
      <div className='splashscreendialog'>
        <div className='splashscreenheader'>Welcome to Casual Combo Country!</div>
        <div className='scrollarea'>
          <div className='splashrow'>
            <div className='splashsection'>
              This is an idle click time-waster where you claim land, build advancements on it,
              and find new combinations which unlock other advancements.
            </div>
          </div>
          <div className='splashrow'>
            <div className='splashsection lp'>
              To claim land you have access to Land Points (LP). Building advancements on unexploited land gives you LP with which to claim new land.
              The more land you cover with advancements, the more new land you can claim.
            </div>
            <div className='splashsection ap'>
              You build advancements with Advancement Points (AP). AP regenerates automatically up to a maximum determined by how much unexploited land you have.
              As you claim more unexploited land, the maximum value your AP can reach will increase.
            </div>
          </div>
          <div className='splashrow'>
            <div className='splashsection'>
              When you build two (or more) advancements next to each other you may unlock new possible advancements.
              Some advancements are upgrades to existing advancements. Each time you use a particular advancement for the first time, AP regeneration speed increases slightly.
            </div>
          </div>
          <div className='logreminder'>Find this and other information again in the log book <img alt="Log" title="Log" src={require(`./images/log.svg`).default} /></div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
